export const USER_LOGIN = 'USER_LOGIN'
export const USER_LOGOUT = 'USER_LOGOUT'
export const USER_REGISTER = 'USER_REGISTER'
export const USER_PLAN = 'USER_PLAN'
export const UPDATELOGGEDINUSER = 'UPDATELOGGEDINUSER'
export const USER_PROFILE = 'USER_PROFILE'
export const GET_USER_PROFILE = 'GET_USER_PROFILE'
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD'
export const USER_LOGIN_OTP = 'USER_LOGIN_OTP'
export const SEND_OTP = 'SEND_OTP'
export const FORGOT_PASSWORD = 'FORGOT_PASSWORD'
export const RESET_PASSWORD = 'RESET_PASSWORD'



// WEBPACK FOOTER //
// ./src/actions/user.js